<template>
  <b-modal id="add-modal" scrollable size="lg" title="Add Folder" no-stacking>
    <form ref="folderform" method="POST" novalidate>
      <div class="form-group required">
        <label class="control-label">Folder Name</label>
        <input
          type="text"
          id="folder_name"
          name="folder_name"
          v-bind:class="{ 'has-error': errors.has('folder_name') }"
          v-validate="'required'"
          v-model="value.folder_name"
          class="form-control site_title"
          placeholder="Folder Name"
        />
        <div class="help text-danger" v-show="errors.has('folder_name')">
          {{ errors.first("folder_name") }}
        </div>
      </div>
    </form>
    <template #modal-footer>
      <div class="w-100">
        <button
          type="submit"
          class="btn btn-dark float-right"
          @click="handleSubmission"
        >
          Save</button
        >&nbsp;&nbsp;
        <button type="reset" class="btn btn-warning" @click="resetForm">
          Reset
        </button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import axios from "axios";

export default {
  name: "AddFolderModal",
  props: [],
  components: {},
  data: () => ({
    value: {
      folder_name: "",
    },
    is_loading: false,
  }),
  mounted() {
    this.value = {};
  },
  methods: {
    updateBoard: function () {},
    addFolder: function () {},
    closeModal: function () {
      this.$bvModal.hide("add-modal");
    },
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/cms_media_manager/mkdir";
          let method = "POST";
          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.closeModal();
              _this.$toaster.success(response.data.message);
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              }
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
              _this.$emit("reload");
              _this.resetForm();
            });
        }
      });
    },
    resetForm: function () {
      this.value = {};
    },
  },
};
</script>
